import React, { Fragment } from 'react'
import { Row, Col, Button, Icon } from 'antd'
import PropTypes from 'prop-types'

import './index.less'

import { Sms } from '/components/SMS/'
import { AnimatedImages } from '/components/AnimatedImages'
import { SelectedGif } from '/components/SelectedGif'
import { MainText } from '/components/MainText'

const returnSelectedGif = gifUrl => {
  if (gifUrl == 'undefined') return null
  else
    return (
      <Row id='gifs'>
        <Col style={{ marginTop: '1vw', display: 'flex' }} lg={{ span: 24 }}>
          <SelectedGif showGiphyLogo={true} gif={gifUrl} />
        </Col>
      </Row>
    )
}

export const Preview = props => (
  <Fragment>
    <Row type='flex'>
      <Col xs={{ span: 24 }} lg={{ span: 13 }}>
        <Button type='primary' id='back-to-edit'>
          <a href='#delivery'>
            <Icon type='left' />
            Voltar para modo edição
          </a>
        </Button>
        <div id='gift-text'>
          <MainText editable={false} title={props.title} text={props.text} />
        </div>
        {returnSelectedGif(props.gifUrl)}
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 11 }} id='images'>
        <div id='component'>
          <Sms isPreviewComponent={true} />
        </div>
        <AnimatedImages />
      </Col>
    </Row>
  </Fragment>
)
Preview.propTypes = {
  /** String chosen by the user to be the title of the gift page */
  title: PropTypes.string,

  /** String chosen by the user to be the text of the gift page */
  text: PropTypes.string,

  /** Gif url chosen by the user */
  gifUrl: PropTypes.string,
}
